import React, { FC, useEffect, useState } from 'react';
import styles from './InfoCardTitle.module.scss';
import Button from 'components/shared/button/Button';
import { useLocation } from 'react-router-dom';
import { ROUTE_USER_RATED_COMPANIES } from 'app-constants';
import ReviewLabel, { TReviewLabel } from 'components/shared/review-label/ReviewLabel';

interface IInfoCardTitle {
  text: string;
  subText?: string;
  clearButton?: boolean;
  onClear?: () => void;
  hasValue?: boolean;
  stepItem?: boolean;
  reviewLabel?: TReviewLabel;
}

export const InfoCardTitle: FC<IInfoCardTitle> = ({
  text,
  subText,
  clearButton,
  onClear,
  hasValue,
  stepItem,
  reviewLabel,
}) => {
  const [buttonActive, setButtonActive] = useState<boolean>(false);
  const [isValue, setIsValue] = useState<boolean>(false);

  const { pathname } = useLocation();

  const onButtonClick = () => {
    setButtonActive(!buttonActive);
    setIsValue(false);
    onClear && onClear();
  };

  useEffect(() => {
    setButtonActive(!hasValue);
  }, [hasValue]);

  return (
    <div className={`${styles.cardTitleContent} ${(clearButton || stepItem) && styles.withClear}`}>
      <div className={`${styles.cardTitleWrapper} ${reviewLabel && styles.withLabel}`}>
        <h3 className={styles.cardTitle}>{text}</h3>
        {clearButton && (
          <Button
            text={'N/A'}
            classList={['btnNA', `${buttonActive || isValue ? 'active' : ''}`]}
            onClick={onButtonClick}
          />
        )}
        {reviewLabel && (
          <div className={styles.reviewLabelWrapper}>
            <ReviewLabel label={reviewLabel || ''} />
          </div>
        )}
      </div>
      {subText && (
        <span
          className={`${
            pathname.includes(ROUTE_USER_RATED_COMPANIES) ? styles.cardText : styles.cardSubText
          }`}
        >
          {subText}
        </span>
      )}
    </div>
  );
};

export default InfoCardTitle;
